import { DESCEND } from "common/constants";
import { columnSorterFunc } from "../brands/brand_columns";
import { Link } from "react-router-dom";

export const BRAND_USER_ID = {
    dataIndex: "brandUserId",
    title: "Brand ID",
};
export const BRAND = {
    dataIndex: "brand",
    title: "Brand",
};
export const BRAND_STATUS_DESCR = {
    dataIndex: "brandStatusDescr",
    title: "Brand Status",
};
export const USER_ID = {
    dataIndex: "userId",
    title: "User ID",
};
export const FULL_NAME = {
    dataIndex: "fullName",
    title: "Full Name",
};
export const ROLE = {
    dataIndex: "role",
    title: "Role",
};
export const INSERT_DATE = {
    dataIndex: "insertDate",
    title: "Date Added",
};

export const columnDef_brandUserId = {
    title: BRAND_USER_ID.title,
    dataIndex: BRAND_USER_ID.dataIndex,
    key: BRAND_USER_ID.dataIndex,
    width: "120px",
    defaultSortOrder: DESCEND,
    sorter: (a, b) => columnSorterFunc(a, b, BRAND_USER_ID.dataIndex),
    render: (text) => <Link to={`/brands/${text}`}>{text}</Link>,
};

export const columnDef_brand = {
    title: BRAND.title,
    dataIndex: BRAND.dataIndex,
    key: BRAND.dataIndex,
    sorter: (a, b) => columnSorterFunc(a, b, BRAND.dataIndex),
};

export const columnDef_brandStatusDescr = {
    title: BRAND_STATUS_DESCR.title,
    dataIndex: BRAND_STATUS_DESCR.dataIndex,
    key: BRAND_STATUS_DESCR.dataIndex,
    width: "130px",
    sorter: (a, b) => columnSorterFunc(a, b, BRAND_STATUS_DESCR.dataIndex),
};

export const columnDef_userId = {
    title: USER_ID.title,
    dataIndex: USER_ID.dataIndex,
    key: USER_ID.dataIndex,
    width: "100px",
    sorter: (a, b) => columnSorterFunc(a, b, USER_ID.dataIndex),
};

export const columnDef_fullName = {
    title: FULL_NAME.title,
    dataIndex: FULL_NAME.dataIndex,
    key: FULL_NAME.dataIndex,
    sorter: (a, b) => {
        const aFullName = `${a.firstName || ""} ${a.lastName || ""}`.trim();
        const bFullName = `${b.firstName || ""} ${b.lastName || ""}`.trim();
        return columnSorterFunc(
            { fullName: aFullName },
            { fullName: bFullName },
            FULL_NAME.dataIndex,
        );
    },
    render: (text, record) => {
        const fullName = `${record.firstName || ""} ${
            record.lastName || ""
        }`.trim();
        return fullName || null;
    },
};

export const columnDef_role = {
    title: ROLE.title,
    dataIndex: ROLE.dataIndex,
    key: ROLE.dataIndex,
    width: "150px",
    sorter: (a, b) => columnSorterFunc(a, b, ROLE.dataIndex),
};

export const columnDef_insertDate = {
    title: INSERT_DATE.title,
    dataIndex: INSERT_DATE.dataIndex,
    key: INSERT_DATE.dataIndex,
    sorter: (a, b) => columnSorterFunc(a, b, INSERT_DATE.dataIndex),
    render: (text) => (text ? new Date(text).toLocaleDateString() : null),
    width: "120px",
};

export const userLookupColumns = [
    columnDef_brandUserId,
    columnDef_brand,
    columnDef_brandStatusDescr,
    columnDef_userId,
    columnDef_fullName,
    columnDef_role,
    columnDef_insertDate,
];
